import React from 'react';
import { defineBlock, smartProps, EditableDiv,useInspectorControl, useSmartProp } from '@smartfire/gutenberg-react';
import style from './block.module.scss';
import { PanelBody, PanelRow, ColorPalette, TextControl} from '@wordpress/components';
import colorPalette from "../shared/colorPalette";


function Inspector(){
    
    const [color, setColor] = useSmartProp("color");
    const [paddingBottom, setPaddingBottom] = useSmartProp("paddingBottom");

     return <>
            <PanelBody title="Paramètres du bloc" initialOpen={true}>
                <PanelRow > 
                     <ColorPalette
                        value={ color }
                        onChange={ ( val ) => setColor( val ) }
                        colors={colorPalette}
                    />
                </PanelRow>
                <PanelRow > 
                     <TextControl
                        label="Marge bas du block"
                        value={ paddingBottom }
                        onChange={ ( val ) => setPaddingBottom( Number(val) ) }
                        type="number"
                    />
                </PanelRow>
            </PanelBody>
        </>;
}



function Block({color, paddingBottom}) {

    useInspectorControl(Inspector);

return <div className={style.block} style={{backgroundColor: color, paddingBottom: paddingBottom}}>
        <div className={style.content}>
            <EditableDiv smartProp="title" tagName="h1" allowedFormats={["advanced/color"]} className={style.title} />
            <EditableDiv smartProp="text" allowedFormats={["core/bold", "advanced/color"]} />
        </div>
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.string.withDefault(""),
        text: smartProps.string.withDefault(""),
        color: smartProps.string.withDefault(style.red),
        paddingBottom: smartProps.number.withDefault(120),
    },
    setup: {
        title: 'Home Page'
    }
})
